import { queryOptions } from '@tanstack/react-query'

import type { SystemLogListResponse } from '@/bindings/SystemLogListResponse'
import { request } from '@/lib/api'
import { type PageSearch, parsePageSearch } from '@/lib/page-search'
import { PAGE_SIZE } from '@/lib/paging'

export type LogLevelFilter = 'error' | 'all'

export interface SystemLogSearch extends PageSearch {
  level: LogLevelFilter
}

/** `?level=all` includes warnings; anything else is the errors-only view. */
export function parseSystemLogSearch(search: Record<string, unknown>): SystemLogSearch {
  return { ...parsePageSearch(search), level: search.level === 'all' ? 'all' : 'error' }
}

export const systemLogKeys = {
  all: ['platform', 'system-log'] as const,
  list: (level: LogLevelFilter, page: number) => ['platform', 'system-log', level, page] as const,
}

export function systemLogListQuery(level: LogLevelFilter, page: number) {
  return queryOptions({
    queryKey: systemLogKeys.list(level, page),
    queryFn: () => request<SystemLogListResponse>(`/platform/system-log?level=${level}&page=${page}&per_page=${PAGE_SIZE}`),
  })
}

/** Field values are shown as text: strings as they are, anything else as JSON. */
export function fieldText(value: unknown): string {
  return typeof value === 'string' ? value : JSON.stringify(value)
}
